<div class="container-fluid container-xxl gx-sm-9 gx-lg-10 gx-xxl-0">
    <!-- Title & Desc -->

    <div class="row">
        <div class="col-12 col-md-4">
            <h3 class="mb-xl-4 mb-5 fs-12 fw-700 ls-2 font-secondary text-secondary text-uppercase" translate>OUR_PRODUCTS.title</h3>
            <p class="mb-7 lh-29" translate>OUR_PRODUCTS.description</p>
        </div>
    </div>

    <!-- Slides -->
    <div class="d-flex align-items-center">
        <!-- Arrow left -->
        <div class="d-none d-md-block">
            <div #swiperNavigationPrev class="categories-arrow categories-arrow-left">
                <span></span>
            </div>
        </div>

        <div class="d-none overflow-hidden d-md-block">
            <div #swiper class="swiper" [class.is-client]="isClient">
                <div class="swiper-wrapper">
                    @for (category of categories; track category.slug) {
                        <div class="swiper-slide">
                            <app-category-thumbnail [category]="category" />
                        </div>
                    }
                </div>
            </div>
        </div>

        <div class="d-md-none">
            <div class="row">
                @for (category of categories; track category) {
                    <div class="col-6">
                        <app-category-thumbnail [category]="category" />
                    </div>
                }
            </div>
        </div>
        <!-- Arrow right -->
        <div class="d-none d-md-block">
            <div #swiperNavigationNext class="categories-arrow categories-arrow-right">
                <span></span>
            </div>
        </div>
    </div>
    <!-- Pagination -->
    <div #swiperPagination class="d-none d-md-block pagination pt-8"></div>
</div>
